export class LegalPressDto {
    id: number;
    date: string;
    description: string;
    title: string;
    path: string

}